import React, { useEffect, useState } from 'react'
import Button from '~/Common-Objects/UI/Forms/Button/Button'
import Icons from '~/Common-Objects/UI/Icons/index'
import TextInput from '~/Common-Objects/UI/Forms/TextInput/TextInput'

import styles from './index.module.scss'

const ImagePicker = ({
    onImageClick,
    imageUrl,
    isEditable,
    isDynamic,
    onCustomUrlClick,
    isCustomUrl,
    onCustomUrlChange,
    onEditClick,
    hideControls
}) => {
    const [fileData, setFileData] = useState(null)
    const [showOpenMediaLibraryButton, setShowOpenMediaLibraryButton] = useState(false)

    const removeCustomUrl = () => {
        onCustomUrlChange('')
        onCustomUrlClick()
        setFileData(null)
    }

    const removeImage = () => {
        onCustomUrlChange('')
        setFileData(null)
    }

    useEffect(() => {
        if (!imageUrl) {
            return
        }

        if (imageUrl.includes('/siteContent/assets/templates/common/image-placeholder.png')) {
            imageUrl = null
        }

        const fetchImage = async () => {
            if (imageUrl) {
                try {
                    getImageMeta(imageUrl).then((meta) => {
                        console.log(meta)
                        setFileData(meta)
                    })
                } catch (error) {
                    console.error('Error fetching image:', error)
                    setFileData(null)
                }
            }
        }
        fetchImage()
    }, [imageUrl])

    if (imageUrl?.includes('/siteContent/assets/templates/common/image-placeholder.png')) {
        imageUrl = null
    }
    if (isCustomUrl && !imageUrl) {
        return (
            <div className={styles.customUrl}>
                <label htmlFor='customImageUrl'>Custom Image URL</label>
                <TextInput
                    name='customImageUrl'
                    type='text'
                    value={imageUrl}
                    onChange={(e) => onCustomUrlChange(e.target.value)}
                />
                <Button
                    iconLeft={<Icons icon='bin' color='red' />}
                    text='Remove'
                    onClick={removeCustomUrl}
                    className='button-xs button-red-ghost'
                    postHogTag='dragdropv2-image-custom-url-remove'
                />
            </div>
        )
    }

    return (
        <>
            <div
                className={styles.root}
                onClick={onImageClick}
                onMouseEnter={() => setShowOpenMediaLibraryButton(true)}
                onMouseLeave={() => setShowOpenMediaLibraryButton(false)}
            >
                {(!imageUrl || showOpenMediaLibraryButton) && (
                    <div
                        style={{
                            position: 'absolute',
                            top: '50%',
                            left: '50%',
                            transform: 'translate(-50%, -50%)',
                            width: '100%',
                            textAlign: 'center'
                        }}
                    >
                        <Button
                            text='Open Media Library'
                            onClick={onImageClick}
                            className='button-primary button-small'
                            postHogTag='dragdropv2-image-change'
                        />
                    </div>
                )}
                {imageUrl && (
                    <div className={styles.imageContainer}>
                        <img src={imageUrl} className={styles.image} alt='' role='presentation' />
                    </div>
                )}
            </div>
            {!imageUrl && !hideControls && (
                <Button
                    iconLeft={<Icons icon='link' />}
                    text='Use Custom Image URL'
                    onClick={onCustomUrlClick}
                    className='button-xs button-like-link mar-t10'
                    postHogTag='dragdropv2-image-use-custom-url'
                />
            )}
            {imageUrl && fileData && !hideControls && (
                <div className={styles.imageMeta}>
                    <h4>{fileData.fileName}</h4>
                    <span>
                        {fileData.width} x {fileData.height}px
                    </span>
                </div>
            )}
            {imageUrl && !hideControls && (
                <div className={styles.editButtons}>
                    {isEditable && !isDynamic && (
                        <Button
                            iconLeft={<Icons icon='edit' />}
                            text='Edit'
                            onClick={onEditClick}
                            className='button-xs button-like-link'
                            postHogTag='dragdropv2-image-edit'
                        />
                    )}
                    <Button
                        iconLeft={<Icons icon='replace' />}
                        text='Replace'
                        onClick={onImageClick}
                        postHogTag='dragdropv2-image-replace'
                    />
                    <Button
                        iconLeft={<Icons icon='bin' color='red' />}
                        text='Remove'
                        onClick={() => removeImage()}
                        className='button-xs button-red-ghost marg-auto-left button-like-link'
                        postHogTag='dragdropv2-image-remove'
                    />
                </div>
            )}
        </>
    )
}

export default ImagePicker

function getImageMeta(url) {
    return new Promise((resolve, reject) => {
        const img = new Image()

        img.onload = () => {
            resolve({
                width: img.width,
                height: img.height,
                fileName: url.split('/').pop().split('?')[0] // best-effort filename
            })
        }

        img.onerror = reject
        img.src = url
    })
}
